"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryReportSchema = exports.InventoryReportCategoryRowSchema = exports.InventoryReportItemSchema = void 0;
const zod_1 = require("zod");
exports.InventoryReportItemSchema = zod_1.z.object({
    productId: zod_1.z.string(),
    variantId: zod_1.z.string().optional(),
    name: zod_1.z.string(),
    sku: zod_1.z.string().optional(),
    categoryId: zod_1.z.string().optional(),
    categoryName: zod_1.z.string().optional(),
    imageUrl: zod_1.z.string().optional(),
    currentStock: zod_1.z.number(),
    reorderPoint: zod_1.z.number().optional(),
    unitCost: zod_1.z.number().optional(),
    stockValue: zod_1.z.number(),
    lastMovementAt: zod_1.z.string().optional(),
    daysSinceLastMovement: zod_1.z.number().optional(),
    avgDailySales: zod_1.z.number().optional(),
    daysOfStockRemaining: zod_1.z.number().optional(),
});
exports.InventoryReportCategoryRowSchema = zod_1.z.object({
    categoryId: zod_1.z.string(),
    categoryName: zod_1.z.string(),
    units: zod_1.z.number(),
    value: zod_1.z.number(),
    itemCount: zod_1.z.number(),
});
exports.InventoryReportSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    generatedAt: zod_1.z.string(),
    totalValue: zod_1.z.number(),
    totalUnits: zod_1.z.number(),
    totalSkus: zod_1.z.number(),
    lowStockCount: zod_1.z.number(),
    outOfStockCount: zod_1.z.number(),
    deadStockCount: zod_1.z.number(),
    overstockCount: zod_1.z.number(),
    byCategory: zod_1.z.array(exports.InventoryReportCategoryRowSchema),
    lowStockItems: zod_1.z.array(exports.InventoryReportItemSchema),
    deadStockItems: zod_1.z.array(exports.InventoryReportItemSchema),
    overstockItems: zod_1.z.array(exports.InventoryReportItemSchema),
});
//# sourceMappingURL=inventory-report.schema.js.map